import { gql, useQuery } from '@apollo/client';
import { get } from 'lodash';

const getErpConnectionAvailabilityQuery = gql`
  query getErpConnectionAvailabilityQuery($jobName: String!) {
    erpConnectionAvailability(jobName: $jobName)
  }
`;

const useErpConnection = ({ jobName }) => {
  const { data } = useQuery(getErpConnectionAvailabilityQuery, {
    variables: {
      jobName
    },
    fetchPolicy: 'cache-and-network',
  });

  const isErpConnectionAvailable = get(data, 'erpConnectionAvailability');

  return { isErpConnectionAvailable };
};

export default useErpConnection;
